import { render } from "./ForeignObject.vue?vue&type=template&id=65b20073"
import script from "./ForeignObject.vue?vue&type=script&lang=js"
export * from "./ForeignObject.vue?vue&type=script&lang=js"

import "./ForeignObject.vue?vue&type=style&index=0&id=65b20073&lang=less"
/* custom blocks */
import block0 from "./ForeignObject.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__